import { ICustomizationsData } from '@/providers/CustomizationsDataProvider';
import { createContext } from 'react';

const CustomizationsDataContext = createContext<{
  data: ICustomizationsData;
  updateCustomizationsDataByKey: (key: keyof ICustomizationsData, value: any) => void;
}>(null);

export default CustomizationsDataContext;
